import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { Episode, EpisodeListItem, PaginatedApiResponse } from '../models';

@Injectable({
  providedIn: 'root'
})
export class EpisodeService {
  private readonly endpoint = '/episodes';

  constructor(private apiService: ApiService) {}

  /**
   * Ottiene tutti gli episodi con paginazione
   */
  getAll(page: number = 1, limit: number = 10): Observable<PaginatedApiResponse<EpisodeListItem>> {
    return this.apiService.get<PaginatedApiResponse<EpisodeListItem>>(this.endpoint, {
      page,
      limit
    });
  }

  /**
   * Ottiene gli ultimi episodi pubblicati
   */
  getLatest(limit: number = 5): Observable<{ success: boolean; data: EpisodeListItem[] }> {
    return this.apiService.get<{ success: boolean; data: EpisodeListItem[] }>(
      `${this.endpoint}/latest`,
      { limit }
    );
  }

  /**
   * Ottiene un episodio per slug
   */
  getBySlug(slug: string): Observable<{ success: boolean; data: Episode }> {
    return this.apiService.get<{ success: boolean; data: Episode }>(
      `${this.endpoint}/${slug}`
    );
  }

  /**
   * Ottiene episodi per categoria
   */
  getByCategory(categorySlug: string, page: number = 1, limit: number = 10): Observable<PaginatedApiResponse<EpisodeListItem>> {
    return this.apiService.get<PaginatedApiResponse<EpisodeListItem>>(
      `${this.endpoint}/category/${categorySlug}`,
      { page, limit }
    );
  }

  /**
   * Ottiene episodi per tag
   */
  getByTag(tagSlug: string, page: number = 1, limit: number = 10): Observable<PaginatedApiResponse<EpisodeListItem>> {
    return this.apiService.get<PaginatedApiResponse<EpisodeListItem>>(
      `${this.endpoint}/tag/${tagSlug}`,
      { page, limit }
    );
  }

  /**
   * Cerca episodi
   */
  search(query: string, page: number = 1, limit: number = 10): Observable<PaginatedApiResponse<EpisodeListItem>> {
    return this.apiService.get<PaginatedApiResponse<EpisodeListItem>>(
      `${this.endpoint}/search`,
      { q: query, page, limit }
    );
  }
}
